<script>
import { VIcon } from 'vuetify/lib/components'
import Toggleable from 'vuetify/lib/mixins/toggleable'
import Transitionable from 'vuetify/lib/mixins/transitionable'
import themeable from 'vuetify/lib/mixins/themeable'

const variants = ['info', 'danger', 'warning', 'default']

export default {
  name: 'EHint',
  mixins: [Toggleable, Transitionable, themeable],
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => {
        return variants.indexOf(value) !== -1
      },
    },
    value: {
      type: Boolean,
      default: true,
    },
    transition: {
      type: String,
      default: 'scale-transition',
    },
  },
  computed: {
    classes() {
      return {
        [`e-hint--${this.variant}`]: true,
        'e-size--small': this.small,
        ...this.themeClasses,
      }
    },
  },
  methods: {
    genIcon() {
      return this.$createElement('div', { staticClass: 'e-hint__icon' }, [
        this.$createElement(
          VIcon,
          {
            props: {
              size: 24,
            },
          },
          'icon-warning-hint-filled'
        ),
      ])
    },
    genContent() {
      const title =
        this.title || this.$slots.default
          ? this.$createElement('div', { staticClass: 'e-hint__content-title' }, this.$slots.default || this.title)
          : null
      const description = this.description
        ? this.$createElement('div', { staticClass: 'e-hint__content-description' }, this.description)
        : null
      return this.$createElement('div', { staticClass: 'e-hint__content' }, [title, description])
    },
    genDismissible() {
      if (!this.dismissible) return null
      return this.$createElement('div', { staticClass: 'e-hint__dismissible' }, [
        this.$createElement(
          VIcon,
          {
            props: {
              size: 24,
            },
            on: {
              click: () => (this.isActive = false),
            },
          },
          'icon-close-sign'
        ),
      ])
    },
    genHint() {
      const data = {
        staticClass: 'e-hint',
        class: this.classes,
        attrs: {
          role: 'hint',
        },
        directives: [
          {
            name: 'show',
            value: this.isActive,
          },
        ],
      }
      // if (!this.value) return null
      return this.$createElement('div', data, [this.genIcon(), this.genContent(), this.genDismissible()])
    },
  },
  render(h) {
    const render = this.genHint()
    if (!this.dismissible) return render
    return h(
      'transition',
      {
        props: {
          name: this.transition,
          origin: this.origin,
          mode: this.mode,
        },
      },
      [render]
    )
  },
}
</script>
